import ConsumerRegistrationPage from '../pages/ConsumerRegistrationPage.vue';
import ChangeToBusinessPage from '../pages/ChangeToBusinessPage.vue';

const consumerRegistrationRoutes = [
  {
    path: '/consumer-registration',
    name: 'فرم ثبت نام',
    component: ConsumerRegistrationPage,
    meta: {
      layout: 'RegisterLayout',
      roles: ['registration'],
    },
  },
  {
    path: '/change-to-business',
    name: 'تغییر به کسب و کار',
    component: ChangeToBusinessPage,
    meta: {
      roles: ['merchant'],
    },
  },
];

export default consumerRegistrationRoutes;
